

/*eslint-disable*/
import React, { useState, useEffect, useRef } from 'react';
import { Tabs, Table, Button, Form, Input, Select, Spin, Space } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, HomeOutlined, SearchOutlined, RedoOutlined, PlusCircleOutlined, EditOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import Message from '../../component/message/message';
import moment from 'moment';//日期格式化导包
import PopupFrame from '../../component/popupFrame/popupFrame';
import Audit from '../../component/audit/audit';//审核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import trans from './translation';
import './cohortProg.css';
import CohortProgModal from './cohortProgModal';

const { TabPane } = Tabs;
const CohortProg = (props) => {
    const [form] = Form.useForm();
    const [form2] = Form.useForm();
    const messageRef = useRef();
    const [tabIndex, setTabIndex] = useState("1");
    const [checkboxState, setCheckboxState] = useState([]);
    const [flag, setFlag] = useState("add");
    const [isAudit, setIsAudit] = useState(false);
    const [isDeleteFrame, setIsDeleteFrame] = useState(false);
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [auditModel, setAuditModel] = useState({});

    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isLeave, setIsLeave] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [groupMemberTables, setGroupMemberTables] = useState([]);
    const [isCohortProgModal, setIsCohortProgModal] = useState(false);
    const [cohortProg, setCohortProg] = useState({});
    const [deleteTipText, setDeleteTipText] = useState("");
    const [cohortList, setCohortList] = useState([]);
    const [deptList, setDeptList] = useState([]);
    const tableColumns = {
        cohortYear: "cohortYear",
        cohortProgId: "cohortProgId",
    }

    useEffect(() => {
        searchCohortList()
        searchAllDept();
    }, []);

    //查询
    const searchAllDept = () => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        Base.callBackApi("commonDropDown/searchAllDept").then((data) => {
            if ("SUCCESS" === data.msg) {
                setDeptList(data.object ?? [])
            } else {
                errFrameShow("error", data.msg);
            }
        })
    }

    const searchCohortList = () => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        Base.callBackApi("cohortProg/searchCohortList").then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object ?? []
                setCohortList(list)
                let newModel = { cohortId: Config?.cohort?.cohortId };
                setSearchModel(newModel);
                form2.setFieldsValue(newModel)
                search(pageSize, 1, "N", false, newModel)
            } else {
                errFrameShow("error", data.msg);
            }
        })
    }

    const search = (pageSizeNew, currentPageNew, flag, isShowMsg, newModel) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();  // 清除提示信息
        let model = {};
        if ("Y" === flag) {     // 翻页
            model = oldSearchModel;
        } else if ("reset" === flag) {
            model = {}
        } else {
            if (newModel) {
                model = JSON.parse(JSON.stringify({ ...searchModel, ...newModel }));
            } else {
                model = JSON.parse(JSON.stringify(searchModel));
            }
        }
        model.page = currentPageNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        // model.progCodeList = Config.userInfo?.progCodeList;
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("cohortProg/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }

    const reset = () => {
        messageShowHandler();
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
        let newModel = { cohortId: Config?.cohort?.cohortId };
        setSearchModel(newModel);
        setOldSearchModel(newModel);
        form2.setFieldsValue(newModel)
    }

    const checkEndDate = (value) => {
        const end = moment(value);
        const start = form.getFieldValue('startDate')
        if (start != "") {
            if (start.isAfter(end)) {
                return Promise.reject("The To Date cannot be earlier than the From Date.")
            }
        }

        return Promise.resolve();
    }
    const checkStartDate = (value) => {
        const end = moment(value);
        const start = form.getFieldValue('endDate')
        if (end != '') {
            if (end.isAfter(start)) {
                return Promise.reject("The From Date cannot be later than the To Date. ")
            }
        }

        return Promise.resolve();
    }


    // Tab页切换
    const handleSelect = (key) => {
        if (key) {
            if (key === "2") {
                if (checkboxState.length === 1 && Config.funcInfo.canUpdate === "Y") {
                    edit();
                } else if (Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else if (tabIndex !== "1") {
                setTabIndex("1");
                search(pageSize, current, "Y");
            }
        }
    }

    const add = () => {
        messageShowHandler();
        initForm({});
        setGroupMemberTables([]);
        setFlag("add");
        setTabIndex("2");
    }
    const download = () => {
        setIsCohortProgModal(true)
    }

    const update = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        searchById(model.cohortProgId)
        setTabIndex("2");
        setFlag("edit");
    }

    const view = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        searchById(model.cohortProgId)
        setTabIndex("2");
        setFlag("view");
    }

    const clone = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        messageShowHandler();
        searchCloneById(model.cohortProgId)
        setTabIndex("2");
        setFlag("clone");

    }
    const edit = () => {
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            cohortId: model.cohortId ?? '',
            progCode: model.progCode ?? "",
            progTitle: model.progTitle ?? "",
            deptCode: model.deptCode ?? "",
        });
    }

    const deleteFrameClose = (state) => {
        if (state) {
            deleteData();
        }
        setIsDeleteFrame(false);
    }

    const deleteData = () => {
        setIsLoad(true);
        setSpinInfo(trans.deleteData[Config.backLang]);
        let deleteModel = cohortProg;
        deleteModel.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi("cohortProg/delete", deleteModel).then((data) => {
            if ("SUCCESS" === data.msg) {
                cancel();
                search(pageSize, current, "Y", false);
                errFrameShow("success", trans.deleteSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const audit = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    const auditCancel = () => {
        setIsAudit(false);
    }

    const onFinish = (values) => {
        messageShowHandler();
        // setIsLoad(true);
        // setSpinInfo(trans.dataBeSaving[Config.backLang])
        values.cohortProgId = cohortProg.cohortProgId
        values.progId = cohortProg.progId
        values.menuFuncId = Config.funcInfo.funcId;
        let url = "";
        if (flag === "add") {
            url = "cohortProg/insert";
        } else if (flag === 'edit') {
            url = "cohortProg/update"
            values.lastUpdatedDate = cohortProg.lastUpdatedDate;
        } else if (flag === 'clone') {
            url = "cohortProg/clone"
            values.lastUpdatedDate = cohortProg.lastUpdatedDate;
        }
        Base.callBackApi(url, values).then((data) => {
            if ("SUCCESS" === data.msg) {
                searchById(data.object)
                setFlag("edit");
                errFrameShow("success", trans.saveSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => {
            setIsLoad(false);
        });
    }

    const searchById = (cohortProgId) => {
        setIsLoading(true);
        Base.callBackApi("cohortProg/searchById", cohortProgId).then((data) => {
            if ("SUCCESS" === data.msg) {
                let cohortProg = data.object;
                initForm(cohortProg);
                setCohortProg(cohortProg)
            } else {
                this.errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoading(false));
    }

    const searchCloneById = (model) => {
        // setIsLoading(true);
        // Base.callBackApi("cohortProg/searchById", model).then((data) => {
        //     if ("SUCCESS" === data.msg) {
        //         let cohortProg = data.object;
        //         initForm(cohortProg);
        //         setCohortProg(cohortProg)
        //         setFlag("clone");
        //     } else {
        //         this.errFrameShow("error", data.msg);
        //     }
        // }).catch(err => { }).finally(() => setIsLoading(false));
    }

    const cancel = () => {
        messageShowHandler();
        setGroupMemberTables([]);
        setTabIndex("1");
        search(pageSize, current, "Y");
    }

    const leaveFrameClose = (state) => {
        if (state) {
            cancel();
        }
        setIsLeave(false);
    }

    const deleteOne = (model, e, type) => {
        e.stopPropagation();
        setCohortProg(model)
        setIsDeleteFrame(true);
        if (type == "segment") {
            setDeleteTipText("Programme Code" + ":" + model.progCode + "")
        }
    }


    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }


    const uploadClose = (flag, model) => {
        if (flag) {
            setCohortProg({
                ...cohortProg,
                progCode: model.progCode,
                progTitle: model.progTitle,
                progId: model.progId
            })
            form.setFieldsValue({
                progCode: model.progCode ?? "",
                progTitle: model.progTitle ?? '',
                deptCode: model.deptCode ?? '',
            });
        }
        setIsCohortProgModal(false);
    }

    const onSearch = () => {
        search(pageSize, 1, "N")
    }

    /*eslint-disable*/
    const columns = [
        {
            title: 'Department',
            dataIndex: 'deptCode',
            className: 'tableWidth29',
            // render: text => deptList.map(item => item.deptId === text && item.deptCode + '-' + item.deptDisplayName)
        },
        {
            title: 'Programme Code',
            dataIndex: 'progCode',
            className: 'tableWidth28',
        },
        {
            title: 'Programme Name',
            dataIndex: 'progTitle',
            className: 'tableWidth28',
        },
        {
            title: 'Cohort',
            dataIndex: 'cohortYear',
            className: 'tableWidth15',
            // sorter: (a, b) => { return Base.sortMethod(a, b, 'cohortYear') },
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            className: ' sysControls',
            fixed: 'right',
            width: 206,
            render: (text, record) => <div className='operation'>
                <div className='sysUpdate' onClick={(e) => update(record, e)} hidden={Config.funcInfo.canUpdate === "N"}><EditOutlined /> {trans.update[Config.backLang]}</div>
                <div className='sysUpdate' onClick={(e) => view(record, e)} hidden={Config.funcInfo.canUpdate === "Y"}><EyeOutlined /> {trans.view[Config.backLang]}</div>
                <div className='sysDelete' onClick={(e) => deleteOne(record, e, "segment")} hidden={Config.funcInfo.canDelete === "N"}><DeleteOutlined /> {trans.delete[Config.backLang]}</div>
                <div className='sysLogs' onClick={(e) => audit(record, e)}><EyeOutlined /> {trans.audit[Config.backLang]}</div>
            </div>
        },
    ];


    return (
        <div id="container" className="template cohortProg">
            <div className='breadcrumb'>
                <HomeOutlined /> / Admin / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : '')]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin size="large" spinning={isLoad} tip={spinInfo}>
                    {/* 删除弹框 */}
                    {isDeleteFrame ? <PopupFrame close={deleteFrameClose} deleteTipText={deleteTipText} /> : null}
                    {isLeave ? <PopupFrame close={leaveFrameClose} type='leave' /> : null}
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane key="1" tab={trans.list[Config.backLang]}>
                            <Form form={form2} onFinish={onSearch}>
                                <div className='sysSearchRow sysSearchBox'>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysTitle mustFill">{trans.cohortYear[Config.backLang]}</div>
                                            <div className="sysSerchInput">
                                                <Form.Item
                                                    name="cohortId"
                                                    rules={[
                                                        { required: true, message: trans.cohortYearNoIsNull[Config.backLang] },
                                                    ]}
                                                >
                                                    <Select className="sysSelect" placeholder={trans.cohortYear[Config.backLang]}
                                                        value={searchModel.cohortId || ''}
                                                        onChange={(e) => searchChange('cohortId', e)}
                                                    >
                                                        <Option value=''></Option>
                                                        {cohortList.map((item) => <Option key={item.cohortId} value={item.cohortId}>{item.cohortYear}</Option>)}
                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysTitle">{trans.deptCode[Config.backLang]}</div>
                                            <div className="sysSerchInput">
                                                <Select className="sysSelect" placeholder={trans.deptCode[Config.backLang]}
                                                    value={searchModel.deptId || ''}
                                                    onChange={(e) => searchChange('deptId', e)}
                                                >
                                                    <Option value=""></Option>
                                                    {deptList.map((item) => <Option key={item.deptId} value={item.deptId}>{item.deptCode + '-' + item.deptDisplayName}</Option>)}
                                                </Select>
                                            </div>
                                        </div>
                                        <div className='sysSearchButton'>
                                            <Button className="sysBtn btnBlue" type="primary" onClick={() => form2.submit()} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                            <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                                        </div>
                                    </div>
                                </div>
                            </Form>
                            <div className="sysLineEight"></div>
                            <Space size={[5, 5]} wrap className="sysButtonRelative">
                                <Button type="primary" className="sysBtn btnBlue" onClick={add} hidden={Config.funcInfo.canInsert === "N"} icon={<PlusCircleOutlined />}>{trans.add[Config.backLang]}</Button>
                            </Space>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    scroll={{ x: 1000 }}
                                    rowKey="cohortProgId" //Key值
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                        onChange: onChange,                        //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,        //每页显示多少条数据方法
                                        total: tablesCount,             //总共多少条数据
                                        current: current,                //当前页
                                        pageSize: pageSize,              //每页显示多少条数据
                                        defaultCurrent: 1,                               //默认当前页为1
                                        size: "small"
                                    }}
                                    onChange={handleTableChange}
                                />
                            </div>
                        </TabPane>
                        <TabPane key="2" tab={trans.cohortProg[Config.backLang]} forceRender={true}>
                            <Form form={form} onFinish={onFinish}>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">Programme Code</div>
                                        <div className="sysInput btnInput">
                                            <Form.Item
                                                name="progCode"
                                                rules={[
                                                    { required: true, message: trans.programmeCodeNoIsNull[Config.backLang] },
                                                ]}
                                            >
                                                <Input type="text" placeholder='Programme Code' maxLength={60} disabled className='BUttonProgramme' />
                                            </Form.Item>
                                        </div>
                                        <Button type="primary" className='sysBtn btnBlue' onClick={download}>Select</Button>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">Programme Name</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="progTitle"
                                                rules={[
                                                    { required: true, message: trans.programmeCodeNoIsNull[Config.backLang] },
                                                ]}
                                            >
                                                <Input type="text" placeholder='Programme Name' maxLength={60} disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.deptCode[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="deptCode"
                                                rules={[
                                                    { required: true, message: trans.deptCodeIsNoNull[Config.backLang] },
                                                ]}
                                            >
                                                <Input type="text" placeholder={trans.deptCode[Config.backLang]} maxLength={60} disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">Cohort</div>
                                        <div className="sysInput ">
                                            <Form.Item
                                                name="cohortId"
                                                rules={[
                                                    { required: true, message: trans.cohortYearNoIsNull[Config.backLang] },
                                                ]}
                                            >
                                                <Select className="sysSelect" placeholder={trans.cohortYear[Config.backLang]} disabled={flag === 'view'}>
                                                    <Option value=''></Option>
                                                    {cohortList.map((item) => <Option key={item.cohortId} value={item.cohortId}>{item.cohortYear}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className="sysSaveButton">
                                    <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} icon={<CheckCircleOutlined />} htmlType="submit">{trans.save[Config.backLang]}</Button>
                                    <Button className="sysBtn" icon={<CloseCircleOutlined />} onClick={cancel}>{trans.cancel[Config.backLang]}</Button>
                                </div>
                            </Form>
                        </TabPane>
                    </Tabs>
                </Spin>
            </div>
            {isCohortProgModal && <CohortProgModal onClose={uploadClose} />}
        </div>
    )

}

export default CohortProg;